const triggerAnimationsNavbar = () => {
  const logoElement = document.querySelector('.navbar--logo');
  const navbarLinks = document.querySelectorAll('.navbar--link');
  const navbarButton = document.querySelector('.navbar--cta');
  const mobileControls = document.querySelector('.navbar--mobilecontrols');
  logoElement.classList.add('navbar--logo-appearing');
  logoElement.addEventListener('animationend', () => logoElement.classList.remove('invisible'));
  navbarLinks.forEach((l, index) => {
    l.classList.add(`navbar--link-appearing-${index}`);
    l.addEventListener('animationend', () => l.classList.remove('invisible'));
  });
  navbarButton.classList.add('navbar--cta-appearing');
  navbarButton.addEventListener('animationend', () => navbarButton.classList.remove('invisible'));
  mobileControls.classList.add('navbar--mobilecontrols-appearing');
  mobileControls.addEventListener('animationend', () => mobileControls.classList.remove('invisible'));
}

const triggerAnimationsHero = () => {
  const heroTitleWords = document.querySelectorAll('.hero--title-word');
  const heroSubtitle = document.querySelector('.hero--subtitle');
  const heroButton = document.querySelector('.hero--button');
  heroTitleWords.forEach((w, index) => {
    w.classList.add(`hero--title-word-appearing`);
    w.classList.add(`hero--title-word-appearing-${index}`);
    w.addEventListener('animationend', () => w.classList.remove('invisible'));
  });
  heroSubtitle.classList.add('hero--subtitle-appearing');
  heroSubtitle.addEventListener('animationend', () => heroSubtitle.classList.remove('invisible'));
  heroButton.classList.add('hero--button-appearing');
  heroButton.addEventListener('animationend', () => heroButton.classList.remove('invisible'));
}

const triggerAnimationsAbout = () => {
  const aboutUsText = document.querySelector('.about--workwith--header');
  const aboutUsLogoContainer = document.querySelector('.about--workwith--logos');
  const aboutUsLogos = document.querySelectorAll('.workwith--logo');
  aboutUsText.classList.add('about--workwith-header-appearing');
  aboutUsText.addEventListener('animationend', () => aboutUsText.classList.remove('invisible'));
  aboutUsLogoContainer.classList.add('about--workwith--logos-appearing');
  aboutUsLogos.forEach((l, index) => {
    l.classList.add(`workwith--logo-appearing`);
    l.classList.add(`workwith--logo-appearing-${index}`);
    l.addEventListener('animationend', () => l.classList.remove('invisible'));
  });
  const aboutBodyOptions = { threshold: 0.4 }
  const aboutBody = document.querySelector('.about--body');
  const observer = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !aboutBody.classList.contains('showing')) {
      aboutBody.classList.add('showing');
      const accent1 = document.querySelector('.about--body--tagline--accent1');
      const accent2 = document.querySelector('.about--body--tagline--accent2');
      const text = document.querySelector('.about--body--tagline-text');
      const descriptionHeader = document.querySelector('.about--body--description--header');
      const descriptionText = document.querySelector('.about--body--description--text');
      const descriptionButton = document.querySelector('.about--body--description--button');
      accent1.classList.add('about--body--tagline--accent1-appearing');
      accent1.addEventListener('animationend', () => accent1.classList.remove('invisible'));
      accent2.classList.add('about--body--tagline--accent2-appearing');
      accent2.addEventListener('animationend', () => accent2.classList.remove('invisible'));
      text.classList.add('about--body--tagline-text-appearing');
      text.addEventListener('animationend', () => text.classList.remove('invisible'));
      descriptionHeader.classList.add('about--body--description--header-appearing');
      descriptionHeader.addEventListener('animationend', () => descriptionHeader.classList.remove('invisible'));
      descriptionText.classList.add('about--body--description--text-appearing');
      descriptionText.addEventListener('animationend', () => descriptionText.classList.remove('invisible'));
      descriptionButton.classList.add('about--body--description--button-appearing');
      descriptionButton.addEventListener('animationend', () => descriptionButton.classList.remove('invisible'));
    }
  }, aboutBodyOptions);
  observer.observe(aboutBody);
}

const triggerAnimationsProcess = () => {
  const processObserverOptions = { threshold: 0.2 };
  const sectionProcess = document.querySelector('.section-process');
  const processObserver = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !sectionProcess.classList.contains('showing')) {
      sectionProcess.classList.add('showing');
      const processHeading = document.querySelector('.process--heading');
      const processSubtitle = document.querySelector('.process--subtitle');
      const processWhiteBox = document.querySelector('.process--realigned');
      const processDashedLine = document.querySelector('.process--accent');
      const workInfoTitle = document.querySelector('.process--work--info--title');
      const workInfoSubtitle = document.querySelector('.process--work--info--subtitle');
      const workInfoText = document.querySelector('.process--work--info--text');
      const processDashedLineEnd = document.querySelector('.process--accent--end');
      processHeading.classList.add('process--heading-appearing');
      processHeading.addEventListener('animationend', () => processHeading.classList.remove('invisible'));
      processSubtitle.classList.add('process--subtitle-appearing');
      processSubtitle.addEventListener('animationend', () => processSubtitle.classList.remove('invisible'));
      processWhiteBox.classList.add('process--realigned-appearing');
      processWhiteBox.addEventListener('animationend', () => processWhiteBox.classList.remove('invisible'));
      processDashedLine.classList.add('process--accent-appearing');
      processDashedLine.addEventListener('animationend', () => processDashedLine.classList.remove('invisible'));
      workInfoTitle.classList.add('process--work--info--title-appearing');
      workInfoTitle.addEventListener('animationend', () => workInfoTitle.classList.remove('invisible'));
      workInfoSubtitle.classList.add('process--work--info--subtitle-appearing');
      workInfoSubtitle.addEventListener('animationend', () => workInfoSubtitle.classList.remove('invisible'));
      workInfoText.classList.add('process--work--info--text-appearing');
      workInfoText.addEventListener('animationend', () => workInfoText.classList.remove('invisible'));
      processDashedLineEnd.classList.add('process--accent--end-appearing');
      processDashedLineEnd.addEventListener('animationend', () => processDashedLineEnd.classList.remove('invisible'));
      const boxesContainer = document.querySelector('.process--work--boxes');
      boxesContainer.classList.add('process--work--boxes--appearing')
      const boxes = document.querySelectorAll('.process--work--box');
      boxes.forEach((b, index) => {
        b.classList.add(`process--work--box-appearing-${index}`);
        b.classList.add(`process--work--box-appearing`);
        b.addEventListener('animationend', () => b.classList.remove('invisible'));
        const children = b.children;
        for(let i = 0 ; i < children.length ; i++) {
          if(children[i].classList.contains('process--work--box--icon')) {
            children[i].classList.add(`process--work--box--icon-appearing-${index}`);
            children[i].classList.add(`process--work--box--icon-appearing`);
            children[i].addEventListener('animationend', () => children[i].classList.remove('invisible'))
          } else {
            children[i].classList.add(`process--work--box--text-appearing-${index}`);
            children[i].classList.add(`process--work--box--text-appearing`);
            children[i].addEventListener('animationend', () => children[i].classList.remove('invisible'))
          }
        }
      })
    }
  }, processObserverOptions);
  processObserver.observe(sectionProcess);
}

const triggerAnimationCTA = () => {
  const ctaObserverOptions = { threshold: 0.2 };
  const sectionCta = document.querySelector('.section-cta');
  const ctaObserver = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !sectionCta.classList.contains('showing')) {
      sectionCta.classList.add('showing');
      const ctaHeader = document.querySelector('.cta-header');
      const ctaText = document.querySelector('.cta-text');
      const ctaButton = document.querySelector('.cta-button');
      ctaHeader.classList.add('cta-header-appearing');
      ctaHeader.addEventListener('animationend', () => ctaHeader.classList.remove('invisible'));
      ctaText.classList.add('cta-text-appearing');
      ctaText.addEventListener('animationend', () => ctaText.classList.remove('invisible'));
      ctaButton.classList.add('cta-button-appearing');
      ctaButton.addEventListener('animationend', () => ctaButton.classList.remove('invisible'));
    }
  }, ctaObserverOptions);
  ctaObserver.observe(sectionCta);
}

const triggerAnimationsJoinUs = () => {
  const joinObserverOptions = { threshold: 0.2 };
  const sectionJoin = document.querySelector('.section-join');
  const joinObserver = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !sectionJoin.classList.contains('showing')) {
      sectionJoin.classList.add('showing');
      const joinLabel = document.querySelector('.join--section-label');
      const joinHeader = document.querySelector('.join--header');
      const joinSubtitle = document.querySelector('.join--subtitle');
      const joinButton = document.querySelector('.join--apply-button');
      joinLabel.classList.add('join--section-label-appearing');
      joinLabel.addEventListener('animationend', () => joinLabel.classList.remove('invisible'));
      joinHeader.classList.add('join--header-appearing');
      joinHeader.addEventListener('animationend', () => joinHeader.classList.remove('invisible'));
      joinSubtitle.classList.add('join--subtitle-appearing');
      joinSubtitle.addEventListener('animationend', () => joinSubtitle.classList.remove('invisible'));
      joinButton.classList.add('join--apply-button-appearing');
      joinButton.addEventListener('animationend', () => joinButton.classList.remove('invisible'));
    }
  }, joinObserverOptions);
  joinObserver.observe(sectionJoin);
}

const triggerAnimationsHeroCareers = () => {
  const careersTitle = document.querySelector('.careers--title');
  const careersSubtitle = document.querySelector('.careers--subtitle');
  const careersButton = document.querySelector('.careers--button');
  const careersSecondSubtitle = document.querySelector('.careers--second-subtitle');
  const careersAccent = document.querySelector('.careers--accent');
  careersTitle.classList.add('careers--title-appearing');
  careersTitle.addEventListener('animationend', () => careersTitle.classList.remove('invisible'));
  careersSubtitle.classList.add('careers--subtitle-appearing');
  careersSubtitle.addEventListener('animationend', () => careersSubtitle.classList.remove('invisible'));
  careersButton.classList.add('careers--button-appearing');
  careersButton.addEventListener('animationend', () => careersButton.classList.remove('invisible'));
  careersSecondSubtitle.classList.add('careers--second-subtitle-appearing');
  careersSecondSubtitle.addEventListener('animationend', () => careersSecondSubtitle.classList.remove('invisible'));
  careersAccent.classList.add('careers--accent-appearing');
  careersAccent.addEventListener('animationend', () => careersAccent.classList.remove('invisible'));
}

const triggerAnimationsTeamCareers = () => {
  const teamObserverOptions = { threshold: 0.2 };
  const sectionTeam = document.querySelector('.section-team');
  const teamObserver = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !sectionTeam.classList.contains('showing')) {
      sectionTeam.classList.add('showing');
      const startAccent = document.querySelector('.team--accent-start');
      const teamTitle = document.querySelector('.team--title-light');
      const endAccent = document.querySelector('.team--accent-end');
      startAccent.classList.add('team--accent-start-appearing');
      startAccent.addEventListener('animationend', () => startAccent.classList.remove('invisible'));
      teamTitle.classList.add('team--title-light-appearing');
      teamTitle.addEventListener('animationend', () => teamTitle.classList.remove('invisible'));
      endAccent.classList.add('team--accent-end-appearing');
      endAccent.addEventListener('animationend', () => endAccent.classList.remove('invisible'));
      const grid = document.querySelector('.team--grid');
      grid.classList.add('team--grid-appearing');
      const boxes = document.querySelectorAll('.team--grid-box');
      boxes.forEach((b, index) => {
        b.classList.add('team--grid-box-appearing');
        b.classList.add(`team--grid-box-appearing-${index}`);
        b.addEventListener('animationend', () => b.classList.remove('invisible'));
        const children = b.children;
        for(let i = 0 ; i < children.length ; i++) {
          if(children[i].classList.contains('team--grid-box-icon')) {
            children[i].classList.add('team--grid-box-icon-appearing');
            children[i].classList.add(`team--grid-box-icon-appearing-${index}`);
          } else if(children[i].classList.contains('team--grid-box-title')) {
            children[i].classList.add('team--grid-box-title-appearing');
            children[i].classList.add(`team--grid-box-title-appearing-${index}`);
          } else {
            children[i].classList.add('team--grid-box-body-appearing');
            children[i].classList.add(`team--grid-box-body-appearing-${index}`);
          }
          children[i].addEventListener('animationend', () => children[i].classList.remove('invisible'));
        }
      })

    }
  }, teamObserverOptions);
  teamObserver.observe(sectionTeam);
}

const triggerAnimationsPositionsCareers = () => {
  const positionsObserverOptions = { threshold: 0.2 };
  const sectionPositions = document.querySelector('.section-positions');
  const positionsObserver = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !sectionPositions.classList.contains('showing')) {
      sectionPositions.classList.add('showing');
      const positionsAccentStart = document.querySelector('.positions--accent-start');
      const positionsTitle = document.querySelector('.positions--title');
      const positionsSubtitle = document.querySelector('.positions--subtitle');
      const positionsContent = document.querySelector('.positions--content');
      positionsAccentStart.classList.add('positions--accent-start-appearing');
      positionsAccentStart.addEventListener('animationend', () => positionsAccentStart.classList.remove('invisible'));
      positionsTitle.classList.add('positions--title-appearing');
      positionsTitle.addEventListener('animationend', () => positionsTitle.classList.remove('invisible'));
      positionsSubtitle.classList.add('positions--subtitle-appearing');
      positionsSubtitle.addEventListener('animationend', () => positionsSubtitle.classList.remove('invisible'));
      positionsContent.classList.add('positions--content-appearing');
      positionsContent.addEventListener('animationend', () => positionsContent.classList.remove('invisible'));
    }
  }, positionsObserverOptions);
  positionsObserver.observe(sectionPositions);
}

const triggerAnimationsPerksCareers = () => {
  const perksObserverHeaderOptions = { threshold: 0.2 };
  const perksObserverGridOptions = { threshold: 0.25 };
  const sectionPerksHeader = document.querySelector('.perks--header');
  const sectionPerksGrid = document.querySelector('.perks--body');
  const perksObserver = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !sectionPerksHeader.classList.contains('showing')) {
      sectionPerksHeader.classList.add('showing');
      const perksTitle = document.querySelector('.perks--title');
      const perksSubtitle = document.querySelector('.perks--subtitle-left-align');
      const perksIconLarge = document.querySelector('.perks--img-fullscreen');
      const perksIconMobile = document.querySelector('.perks--img-mobile');
      perksTitle.classList.add('perks--title-appearing');
      perksTitle.addEventListener('animationend', () => perksTitle.classList.remove('invisible'));
      perksSubtitle.classList.add('perks--subtitle-appearing');
      perksSubtitle.addEventListener('animationend', () => perksSubtitle.classList.remove('invisible'));
      perksIconLarge.classList.add('perks--img-fullscreen-appearing');
      perksIconLarge.addEventListener('animationend', () => perksIconLarge.classList.remove('invisible'));
      perksIconMobile.classList.add('perks--img-mobile-appearing');
      perksIconMobile.addEventListener('animationend', () => {
        perksIconMobile.classList.remove('invisible');
        perksIconMobile.classList.remove('perks--img-mobile-appearing');
      });
    }
  }, perksObserverHeaderOptions);
  const perksGridObserver = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !sectionPerksGrid.classList.contains('showing')) {
      sectionPerksGrid.classList.add('showing');
      const cardsContainer = document.querySelector('.perks--body');
      cardsContainer.classList.add('perks--body-appearing');
      const cards = document.querySelectorAll('.perks--card');
      cards.forEach((c,index)  => {
        c.classList.add('perks--card-appearing');
        c.classList.add(`perks--card-appearing-${index}`);
        const children = c.children;
        for(let i = 0 ; i < children.length ; i++) {
          if(children[i].classList.contains('perks--card-left-line')) {
            children[i].classList.add(`perks--card-left-line-appearing`);
            children[i].classList.add(`perks--card-left-line-appearing-${index}`);
          } else if(children[i].classList.contains('perks--card-body')) {
            children[i].classList.add(`perks--card-body-appearing`);
            children[i].children[0].classList.add(`perks--card-body-title-appearing`);
            children[i].children[0].classList.add(`perks--card-body-title-appearing-${index}`);
            children[i].children[1].classList.add(`perks--card-body-subtitle-appearing`);
            children[i].children[1].classList.add(`perks--card-body-subtitle-appearing-${index}`);
            children[i].children[0].addEventListener('animationend', () => children[i].children[0].classList.remove('invisible'));
            children[i].children[1].addEventListener('animationend', () => children[i].children[1].classList.remove('invisible'));
          }
          children[i].addEventListener('animationend', () => children[i].classList.remove('invisible'));
        }
      })
    }
  }, perksObserverGridOptions);
  perksObserver.observe(sectionPerksHeader);
  perksGridObserver.observe(sectionPerksGrid);
}

const triggerAnimationsContactCareers = () => {
  const contactObserverOptions = { threshold: 0.2 };
  const sectionContact = document.querySelector('.section-contact');
  const contactObserver = new IntersectionObserver(entries => {
    if(entries[0].isIntersecting && !sectionContact.classList.contains('showing')) {
      sectionContact.classList.add('showing');
      const contactTitle = document.querySelector('.contact--title');
      const contactSubtitle = document.querySelector('.contact--subtitle');
      const contactButton = document.querySelector('.contact--button');
      contactTitle.classList.add('contact--title-appearing');
      contactTitle.addEventListener('animationend', () => contactTitle.classList.remove('invisible'));
      contactSubtitle.classList.add('contact--subtitle-appearing');
      contactSubtitle.addEventListener('animationend', () => contactSubtitle.classList.remove('invisible'));
      contactButton.classList.add('contact--button-appearing');
      contactButton.addEventListener('animationend', () => contactButton.classList.remove('invisible'));
    }
  }, contactObserverOptions);
  contactObserver.observe(sectionContact);
}

export const triggerHomepageAnimations = () => {
  //triggerAnimationsNavbar();
  if(!window.location.href.includes('/careers')) {
    triggerAnimationsHero();
    triggerAnimationsAbout();
    triggerAnimationsProcess();
    triggerAnimationCTA();
    triggerAnimationsJoinUs();
  } else {
    triggerAnimationsHeroCareers();
    triggerAnimationsTeamCareers();
    triggerAnimationsPositionsCareers();
    triggerAnimationsPerksCareers();
    triggerAnimationsContactCareers();
  }
}